import { WhitelabelKey } from "../globals";

export interface BrandingConfig {
  logo: string;
  loginBackgroundImage: string;
  loginBackgroundColor: string;
  searchStatusImage: string;
  siteBackground: string;
  primaryColor: string;
  headerColor: string;
  headerImage: string;
  middleColor: string;
  backlinkColor: string;
  mobileTextColor: string;
  mobileCardShadow: string;
  mobileHeaderImage: string;
  mobileHeaderImageHighContrast: string;
  mobileNavbarColor: string;
  mobileCalendarBackground: string;
  faviconPrefix: string;
  title: string;
  highContrastVisiblity: boolean;
}

export const brandingConfig: Record<WhitelabelKey, BrandingConfig> = {
  nj: {
    logo: "assets/images/myhealthnj_logo.png",
    headerImage: "assets/images/myhealthnj_logo_white.png",
    loginBackgroundImage: "assets/images/NJ_Hi-res_White.png",
    searchStatusImage: "/assets/images/nj-logo-blue.png",
    loginBackgroundColor: "#054f90",
    siteBackground: "#EEEEEE",
    primaryColor: "#4d834c",
    headerColor: "#054f90",
    middleColor: "#EEEEEE",
    backlinkColor: "dark",
    mobileTextColor: "black",
    mobileCardShadow: "4px 4px 4px 0px rgba(0, 0, 0, 0.1)",
    mobileHeaderImage: "assets/images/myhealthnj_logo.png",
    mobileHeaderImageHighContrast: "assets/images/myhealthnj_logo.png",
    mobileCalendarBackground: "#4d834c",
    mobileNavbarColor: "#054f90",
    faviconPrefix: "/nj-favicon",
    title: "MyHealthNJ | Docket®",
    highContrastVisiblity: false,
  },
  /* default "docket" styles */
  default: {
    logo: "assets/images/Docket_Logo_Blue.png",
    headerImage: "assets/images/Docket_Logo_White.png",
    searchStatusImage: "/assets/images/Docket_Jim_Light.png",
    loginBackgroundImage: "assets/images/Doctors_No-Background.png",
    loginBackgroundColor: "#c2e2ff",
    siteBackground: "rgb(28, 154, 212)",
    primaryColor: "rgb(28, 154, 212)",
    headerColor: "#032238",
    middleColor: "#237bb8",
    backlinkColor: "white",
    mobileTextColor: "white",
    mobileCardShadow: "0 4px 0px 0px #237bb8",
    mobileHeaderImage: "assets/images/Docket_Logo_White.png",
    mobileHeaderImageHighContrast: "assets/images/Docket_Logo_Blue.png",
    mobileNavbarColor: "rgb(28, 154, 212)",
    mobileCalendarBackground: "#ffffff29",
    faviconPrefix: "",
    title: "Docket®",
    highContrastVisiblity: true,
  },
};
